import React from "react";
import { connect } from "react-redux";
import { concat, isEmpty, map, pluck } from "ramda";
import {
  removeFacet,
  removeQuery,
  showFacetDialog,
} from "browse-media/redux/browseMediaActions";
import FacetBar from "components/faceted-search/FacetBar";
import FacetPill from "components/faceted-search/FacetPill";

const getLabels = (facet, publicationYearGroups) => {
  const termLabels = pluck("label", facet.terms);

  return facet.name === "contentDatePublished"
    ? concat(pluck("name", publicationYearGroups), termLabels)
    : termLabels;
};

const BrowseMediaFacetBar = ({
  appliedFacets,
  appliedPublicationYearGroups,
  appliedQuery,
  onClickFacet,
  onRemoveFacet,
  onRemoveQuery,
}) => (
  <FacetBar>
    {!isEmpty(appliedQuery) && (
      <FacetPill
        key="appliedQuery"
        displayName="Search"
        labels={[appliedQuery]}
        onRemove={() => onRemoveQuery()}
      />
    )}
    {map(
      f => (
        <FacetPill
          key={f.name}
          displayName={f.displayName}
          labels={getLabels(f, appliedPublicationYearGroups)}
          onClick={() => onClickFacet(f.name)}
          onRemove={() => onRemoveFacet(f.name)}
        />
      ),
      appliedFacets,
    )}
  </FacetBar>
);

const mapStateToProps = state => {
  const {
    appliedFacets,
    appliedPublicationYearGroups,
    appliedQuery,
  } = state.browseMedia;

  return {
    appliedFacets,
    appliedPublicationYearGroups,
    appliedQuery,
  };
};

const mapDispatchToProps = dispatch => ({
  onClickFacet: facet => dispatch(showFacetDialog(facet)),
  onRemoveFacet: facet => dispatch(removeFacet(facet)),
  onRemoveQuery: () => dispatch(removeQuery()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BrowseMediaFacetBar);
